<template lang="pug">
Page.residential-edit
    .residential-edit__top(
        slot="header"
    )
        h1.residential-edit__title
            | Создание жилого комплекса

        SvMenu(
            @remove="remove"
            @copy="copy"
        )

    SvTabs.residential-edit__table(
        v-model="current"
        :tabs="['Основное', 'О проекте', 'Фото', 'Планировки', 'Другое', 'SEO']"
    )
        .residential-edit__actions
            SvButton.residential-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.residential-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.residential-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )

    keep-alive
        FormResidentialMain(
            v-if="current === 0"
        )

        FormResidentialAbout(
            v-if="current === 1"
        )

        FormResidentialPhoto(
            v-if="current === 2"
        )

        FormResidentialPlans(
            v-if="current === 3"
        )

        FormResidentialOther(
            v-if="current === 4"
        )

        FormResidentialSeo(
            v-if="current === 5"
        )
</template>

<script>
import FormResidentialSeo from '@/components/forms/FormResidentialSeo.vue';
import FormResidentialPlans from '@/components/forms/FormResidentialPlans.vue';
import FormResidentialOther from '@/components/forms/FormResidentialOther.vue';
import FormResidentialPhoto from '@/components/forms/FormResidentialPhoto.vue';
import FormResidentialAbout from '@/components/forms/FormResidentialAbout.vue';
import FormResidentialMain from '@/components/forms/FormResidentialMain.vue';
import SvDatePicker from '@/components/uikit/SvDatePicker.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'ResidentialEdit',

  data() {
    return {
      current: 0,
      developer: null,
      position: '',
      dateFinishFrom: null,
      dateFinishTo: null,
      distinct: '',
      adress: '',
      geo: '',
      advantages: [],
      plans: [],
      banks: [],
    };
  },

  beforeMount() {
    this.$store.dispatch('residential/getParamsHack');
    this.$store.dispatch('residential/getById', this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('residential/getById', to.params.id);
    }
    next();
  },

  methods: {
    ...mapMutations({
      setValue: 'residential/setValue',
      clearCurrent: 'residential/clearCurrent',
    }),

    resetForm() {
      this.clearCurrent();
      this.$router.push({ name: 'residentials' });
    },

    copy() {
      this.$store.commit('residential/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({
        name: 'ResidentialEdit',
        params: {
          id: 'new',
        },
      });
    },

    async remove() {
      await this.$store.dispatch('residential/remove', this.$route.params.id);
      this.$router.push({ name: 'residentials' });
    },

    async save(isRedirect = false) {
      const id = await this.$store.dispatch('residential/save');
      if (!isRedirect) {
        this.$router.push({
          name: 'residential-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.$router.push({ name: 'residentials' });
      }
    },
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvDatePicker,
    FormResidentialMain,
    FormResidentialAbout,
    FormResidentialPhoto,
    FormResidentialOther,
    FormResidentialPlans,
    FormResidentialSeo,
  },
};
</script>

<style lang="scss" scoped>
.residential-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.residential-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.residential-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.residential-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.residential-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.residential-edit__form {
    padding: 50px 0;
}

.residential-edit__form-radio {
    margin-right: 21px;
}

.residential-edit__form-elements--medium {
    width: 495px;
}


.residential-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.residential-edit__search {
    width: 47%;
    min-width: 280px;
}
</style>
